<template>
    <div class="droite">
    <component
                :is="currentTab.name" :config="currentTab.config" v-if="renderComponent"
        @reload="reload"></component>
    </div>
</template>

<script>

    import TabLien from './tabs/TabLien.vue';
    import TabResultat from './tabs/TabResultat.vue';
    import TabHelp from './tabs/TabHelp.vue';
    import TabTache from './tabs/TabTache.vue';
    import TabDialogue from './tabs/TabDialogue.vue';

    export default {
        components:{

            TabLien,
            TabResultat,
            TabHelp,
            TabTache,
            TabDialogue

        },
        data(){
            return {
                currentTab:{ name:'TabHelp', config:''},

                renderComponent:true,
            }
        },
        watch: {

        },
        computed: {

        },
        methods: {
            forceRerender() {
                // Remove my-component from the DOM
                this.renderComponent = false;

                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });
            },

            reload(){
                //this.$emit('reload')
                location.reload()
            }
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getDroite,
                (newValue, oldValue) => {
                    this.currentTab=newValue
                    this.forceRerender()
                },
            );
        },
    }
</script>


<style lang="scss">

    .droite{
        width:100%;
        max-height: calc(100vh - 9rem);
        overflow-y: auto;
        padding:10px;
    }

</style>